import { render, staticRenderFns } from "./NewEditAulaEletivoPage.vue?vue&type=template&id=21f9401e"
import script from "./NewEditAulaEletivoPage.vue?vue&type=script&lang=js"
export * from "./NewEditAulaEletivoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports